import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import MuiTypography from '@mui/material/Typography';
import MuiMenuItem from '@mui/material/MenuItem';
import { useOverflow } from '../OverflowProvider.js';

const Root = styled(MuiMenuItem) `
  cursor: default;
  ${({ theme }) => `
    color: ${theme.palette.N30.main};
    &:hover {
      background-color: ${theme.palette.N40.main};
      color: ${theme.palette.N30.main};
    }
  `}
`;
const MenuCategory = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    const { dense } = useOverflow();
    return (jsx(Root, Object.assign({}, rest, { dense: dense }, { children: jsx(MuiTypography, Object.assign({ variant: dense ? 'subtitle2' : 'subtitle1' }, { children: children })) })));
};

export { MenuCategory as default };
//# sourceMappingURL=MenuCategory.js.map
